/* eslint-disable indent */
import React from "react";
import { ViewDetailsHeading } from "../../../../components/ViewDetailsHeading";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewPersonalDetails({ personalDetails, apiResponse, id }) {
  return (
    <>
      {" "}
      <ViewDetailsHeading
        text={"Proprietor / Personal details"}
        itemkey={2}
        apiResponse={apiResponse}
        id={id}
      />
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">Personal Details</div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"Name"} hub={personalDetails?.name} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Office Email ID"}
                  hub={personalDetails?.email}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Office contact no"}
                  hub={personalDetails?.contactNo}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"DOB"} hub={personalDetails?.dob} />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Personal contact no"}
                  hub={personalDetails?.altContactNo}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Personal Email Id"}
                  hub={personalDetails?.personalEmailId}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Contact Number"}
                  hub={personalDetails?.contactNumber}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
